import { render, staticRenderFns } from "./LeaderboardWinner.vue?vue&type=template&id=0b404fe9&scoped=true"
import script from "./LeaderboardWinner.vue?vue&type=script&lang=js"
export * from "./LeaderboardWinner.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardWinner.vue?vue&type=style&index=0&id=0b404fe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b404fe9",
  null
  
)

export default component.exports